import React from 'react';

interface SortArrowIconProps {
    width?: number | string;
    height?: number | string;
    fill?: string;
    iconClassName?: string;
}

export const SortArrowIcon: React.FC<SortArrowIconProps> = ({
    width = 12,
    height = 8,
    fill = '#7F7F7F',
    iconClassName,
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={iconClassName}
        >
            <path
                d="M-6.16331e-08 6.00016L1.41 7.41016L6 2.83016L10.59 7.41016L12 6.00016L6 0.00015614L-6.16331e-08 6.00016Z"
                fill={fill}
            />
        </svg>
    );
};
